import { updateBookingShareState } from '../../../actions/booking';

const submitExampleForm = ({ shareState }, dispatch, { bookingId, accessToken, submitCallback }) => {
  dispatch(updateBookingShareState(bookingId, shareState, accessToken, submitCallback));
};

export default submitExampleForm;
